/** BAO-995: leaf thead text → td[data-name] so stacked cards keep column labels.
 *  Fluid columns (no nzWidth) get ellipsis so names shrink instead of covering neighbours.
 */

export function stampTableCardLabels(root: HTMLElement): void {
  const hosts: HTMLElement[] = root.tagName === 'NZ-TABLE'
    ? [root]
    : Array.from(root.querySelectorAll('nz-table'));

  (hosts.length ? hosts : [root]).forEach(stampHost);
}

function stampHost(host: HTMLElement): void {
  const headingRows = host.querySelectorAll<HTMLTableRowElement>('.ant-table-thead tr');
  const leafHead = headingRows[headingRows.length - 1];
  if (!leafHead) {
    return;
  }

  const ths = Array.from(leafHead.querySelectorAll<HTMLTableCellElement>('th'));
  const headings = ths.map(th => (th.textContent || '').replace(/\s+/g, ' ').trim());
  const fluid = ths.map(isFluidHeader);

  host.querySelectorAll<HTMLTableRowElement>('.ant-table-thead tr').forEach(tr => {
    tr.querySelectorAll<HTMLTableCellElement>('th').forEach((th, i) => toggleEllipsisClass(th, fluid[i] === true));
  });

  host.querySelectorAll<HTMLTableRowElement>('tbody tr').forEach(tr => {
    if (tr.classList.contains('ant-table-measure-now')) {
      return;
    }
    tr.querySelectorAll<HTMLTableCellElement>('td').forEach(td => {
      const name = headings[td.cellIndex] ?? '';
      if (name) {
        td.setAttribute('data-name', name);
      } else {
        td.removeAttribute('data-name');
      }

      const ellipsis = fluid[td.cellIndex] === true
        && !td.classList.contains('nz-disable-td')
        && !td.classList.contains('cell-nowrap')
        && !td.classList.contains('ant-table-selection-column')
        && !td.classList.contains('ant-table-cell-fix-right')
        && !td.classList.contains('ant-table-cell-fix-left');
      toggleEllipsisClass(td, ellipsis);
      if (ellipsis) {
        const text = (td.textContent || '').replace(/\s+/g, ' ').trim();
        if (text && td.getAttribute('title') !== text) {
          td.setAttribute('title', text);
        }
      }
    });
  });
}

function isFluidHeader(th: HTMLTableCellElement): boolean {
  if (th.classList.contains('ant-table-cell-fix-right')
    || th.classList.contains('ant-table-cell-fix-left')
    || th.classList.contains('ant-table-selection-column')) {
    return false;
  }
  const label = (th.textContent || '').replace(/\s+/g, ' ').trim();
  if (!label) {
    return false;
  }
  const declared = parseFloat(th.getAttribute('nzwidth') || '');
  return !(Number.isFinite(declared) && declared > 0);
}

function toggleEllipsisClass(el: HTMLElement, on: boolean): void {
  if (on) {
    el.classList.add('cell-ellipsis');
  } else {
    el.classList.remove('cell-ellipsis');
  }
}
